import { SelectedMarker } from '@/entities/map'
import {
  createOverlay,
  createBaseOverlay,
  type BaseOverlay,
  type BaseOverlayOptions,
} from '@/shared/lib'

export type SubwayOverlayProps = Omit<
  BaseOverlayOptions,
  'map' | 'position'
> & {
  onClick: (bounds?: SelectedMarker) => void
}

type SubwayOverlayOptions = BaseOverlayOptions & SubwayOverlayProps

export interface SubwayOverlay extends BaseOverlay {
  isSelected: boolean
  markAsSelected(): void
  markAsDeselected(): void
}

export const createSubwayOverlay = () => {
  const BaseOverlay = createBaseOverlay()

  const SubwayOverlay = createOverlay<SubwayOverlay, SubwayOverlayOptions>({
    base: BaseOverlay,
    initialize,
  })

  function initialize(this: SubwayOverlay, options: SubwayOverlayOptions) {
    this.isSelected = false

    this._onClick = () => {
      this.markAsSelected()

      options.onClick?.({
        id: this.id,
        type: 'subway',
        position: {
          lat: this.getPosition().lat(),
          lng: this.getPosition().lng(),
        },
        nextZoomLevel: options.nextZoomLevel,
      })
    }
  }

  SubwayOverlay.prototype.markAsSelected = function () {
    if (this._element.firstElementChild instanceof HTMLElement) {
      this.isSelected = true
      this._element.firstElementChild.classList.add('selected')
    }
  }

  SubwayOverlay.prototype.markAsDeselected = function () {
    if (this._element.firstElementChild instanceof HTMLElement) {
      this.isSelected = false
      this._element.firstElementChild.classList.remove('selected')
    }
  }

  return SubwayOverlay
}
